import { Skeleton } from '@reveni-io/reveni-ui'

const DeleteReturnInstructionModalSkeleton = () => (
  <>
    <Skeleton height={20} width="60%" />
    <Skeleton height={40} />
    <Skeleton height={40} />
  </>
)

export default DeleteReturnInstructionModalSkeleton
